import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';
import { lastSeenDescription } from '../../../services/DeviceUtils.js';
import { DeviceBatteryIndicator } from '../../bits/DeviceBatteryIndicator.tsx';
import { DeviceChargingIndicator } from '../../bits/DeviceChargingIndicator.tsx';
import DeviceImage from '../DeviceImage.jsx';
import { DeviceStatusTag } from './DeviceStatusTag.tsx';

const DeviceStatusContainer = styled.span`
  display: flex;
  gap: 4px;
  align-items: center;

  @media (max-width: 500px) {
    flex-direction: row-reverse;
  }
`;

const Icons = styled.span`
  display: flex;
  color: #4a4a4a;
`;

class DeviceInfoSection extends Component {
  render() {
    const { device } = this.props;
    const {
      id, name, imei,
    } = device;

    return (
      <div className="section">
        <div className="device-header">
          <div className="device-header__info">
            <div className="device-header__info-top">
              <div>
                <span className="device-header__title">
                  {name}
                </span>
                <Link to={{
                  pathname: `${id}/name`,
                  state: { origin: 'device_info' },
                }}>
                  <span className="device-header__edit-icon">
                    <i className="fa fa-pencil"></i>
                  </span>
                </Link>
              </div>
              <p className="device-header__subtitle">
                IMEI: {imei}
              </p>
            </div>
            <div className="device-header__info-bottom">
              <DeviceStatusContainer>
                <DeviceStatusTag device={device} />

                { device.model === 'AT1' && (
                  <Icons>
                    <DeviceBatteryIndicator device={device} />
                    <DeviceChargingIndicator charging={device.charging} />
                  </Icons>
                )}
              </DeviceStatusContainer>
              Last seen {lastSeenDescription(device)}
            </div>
          </div>
          <div className="device-header__photo">
            <DeviceImage device={device} size="medium" />
          </div>
        </div>
      </div>
    );
  }
}

export default DeviceInfoSection;
